"use client";

import React, { useRef } from "react";
import Image from "next/image";
import mail from "../../assets/icons/mail.svg";
import Button from "../shared/Button";
import { addUserEmail } from "../../lib/supabase/actions";
import { emailSchema } from "../../lib/types/schema";
import { toast } from "../shared/Toast";

const SaveEmailInput = () => {
  const formRef = useRef<HTMLFormElement>(null);

  const sendEmail = async (formData: FormData) => {
    const email = formData.get("email") as string;

    try {
      toast({
        title: "Signing you up ✉️",
        description: "Please wait while we send the email...",
        variant: "info",
      });
      // client side validation
      const result = emailSchema.safeParse({ email });

      if (!result.success) {
        let errorMessage = "";
        for (const issue of result.error.issues) {
          errorMessage += issue.path[0] + ": " + issue.message + "\n";
        }
        toast({
          title: "Validation Error",
          description: errorMessage,
          variant: "error",
        });
        return;
      }

      if (email) {
        await addUserEmail({ email });
        // Clear the form
        formRef.current?.reset();
        toast({
          title: "Success!",
          description:
            "You've been added to the waitlist. Check your email for updates! 🎉",
          variant: "success",
        });
      }
    } catch (error) {
      // Check if it's the duplicate email error
      if (error instanceof Error) {
        toast({
          title: "Error",
          description:
            "Failed to add you to the waitlist or you already exist on the waitlist. Please try again later.",
          variant: "error",
        });
      }
    }
  };

  return (
    <form
      ref={formRef}
      className="flex max-sm:flex-col items-center gap-8 sm:gap-2.5 max-sm:w-full"
      action={sendEmail}
    >
      <div className="relative flex items-center max-sm:w-full">
        <Image
          src={mail}
          alt="mail icon"
          className="absolute left-5 w-5 h-5 opacity-50"
        />
        <input
          className="border border-gray-300 rounded-[32px] py-[18px] pl-12 pr-5 max-sm:w-full sm:w-[490px] h-[56px] text-gray-400 focus:outline-none focus:border-gray-300"
          placeholder="Serious about studying? Prove it, sign up now!"
          name="email"
        />
      </div>

      <Button text={"Join Waitlist"} />
    </form>
  );
};

export default SaveEmailInput;
